import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=af136c84"
import script from "./DocumentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports